module.exports = __webpack_public_path__ + "static/emiWhite-9111d6c3a82659ef24ccbbf5649f6cc9.svg";